export const useSeo = (
   title: MaybeRefOrGetter<string | undefined>,
   description: MaybeRefOrGetter<string | undefined>
) => {
   const { t } = useI18n()

   const fullTitle = computed(() => toValue(title) || t('web.seo.layout.default.title'))
   const fullDescription = computed(
      () => toValue(description) || t('web.seo.layout.default.description')
   )

   useHead({ title: fullTitle })

   useSeoMeta({
      description: () => fullDescription.value,
      ogTitle: () => fullTitle.value,
      ogDescription: () => fullDescription.value,
   })

   defineOgImage('OGImage' as never, { title: fullTitle })
}
